export const extensionName = '@bangle.io/core-extension';

export const CORE_OPERATIONS_RENAME_ACTIVE_NOTE =
  'operation::@bangle.io/core-extension:RENAME_ACTIVE_NOTE';

export const CORE_OPERATIONS_TOGGLE_NOTE_SIDEBAR =
  'operation::@bangle.io/core-extension:NOTE_TOGGLE_SIDEBAR';

export const CORE_OPERATIONS_TOGGLE_UI_COLOR_SCHEME =
  'operation::@bangle.io/core-extension:TOGGLE_UI_COLOR_SCHEME';

export const CORE_OPERATIONS_DOWNLOAD_WORKSPACE_COPY =
  'operation::@bangle.io/core-extension:DOWNLOAD_WORKSPACE_COPY';

export const CORE_OPERATIONS_NEW_WORKSPACE_FROM_BACKUP =
  'operation::@bangle.io/core-extension:NEW_WORKSPACE_FROM_BACKUP';

export const CORE_OPERATIONS_DELETE_ACTIVE_NOTE =
  'operation::@bangle.io/core-extension:DELETE_ACTIVE_NOTE';
